"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
// @ts-ignore-next-line 7016
const react_notifications_1 = require("react-notifications");
const NotificationsContainer = ({ stacked }) => {
    const wrapperClasses = (0, classnames_1.default)('notification-container-wrapper', stacked && 'stacked');
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: wrapperClasses }, { children: (0, jsx_runtime_1.jsx)(react_notifications_1.NotificationContainer, {}) })));
};
exports.default = NotificationsContainer;
